export default __webpack_public_path__ + "static/media/cream-logo.29138554.svg";